import { AyudaActionTypes, SET_AYUDA } from "../types/ayudaActionTypes";

export function setAyuda(ayuda: any): AyudaActionTypes {
    return{
        type: SET_AYUDA,
        ayuda
    }
}
